
export const TableHeader = () =>  {
    return <tr className="SummativeStudentsReport__table__row">
        <th className="SummativeStudentsReport__table__row__studentId fontBold ">Student ID <br/> Last 5</th>
        <th className="SummativeStudentsReport__table__row__Name fontBold ">Student</th>
        <th className="SummativeStudentsReport__table__row__proficiency fontBold">Proficiency</th>
        <th className="SummativeStudentsReport__table__row__pecentage fontBold">Test Score</th>
    </tr>
}
export default TableHeader